import React, { useState,useEffect } from 'react'
import { Footer } from '../../common/footer/footer';
import { OfferCardListJSX } from '../../common/offerCardList/offerCardList';
import { ArticlesCardJSX } from '../../common/articlesCard/articlesCard';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import { Link } from "react-router-dom";
import 'aos/dist/aos.css';
import "../category/category.css";
import iconaskbtn from "../../../assets/sharedImages/iconaskbtn.svg";

import { Trans, useTranslation } from 'react-i18next';
import RealEtext from "../../../assets/realEstateimages/RealEtext.png";
import RealEtextIns from "../../../assets/insuranceimges/RealEtext.png";
import RealEtextMor from "../../../assets/mortgageimges/RealEtext.png";
import RealEtextInvest from "../../../assets/investmentimages/RealEtext.png";
import RealEtextBank from "../../../assets/bankingimges/RealEtext.png";


import dropbox from "../../../assets/images/dropbox.svg";
import Realestatebanner from "../../../assets/realEstateimages/RealEstateimage.svg";
import Insurancebanner from "../../../assets/insuranceimges/Insurance_image.svg";
import Mortgagebanner from "../../../assets/mortgageimges/Mortgage_image.svg";
import Investmentbanner from "../../../assets/investmentimages/Investmentimage.svg";
import Bankingbanner from "../../../assets/bankingimges/Banking_image.svg";

import DetailedProductsJsx from '../../common/detailedProduct/detailedProduct.jsx';
import ExpertCardJsx from "../../common/expertCard/expertCard.jsx"
import InstituteList from "../../common/instituteList/instituteList.jsx"
import ProductCardList from "../../common/productCardList/productCardList.jsx"

const CategoryJsx = (props) => {
  const { t } = useTranslation();
  const {
    offerData,
    productData,
    expertData,
    instituteData,
    blogData,
    onInstituteClick, mainCatID
  } = props;

  const [visibleBlogs] = useState(4);

  const [productDetails, setProductDetails] = useState({});

  const closeFunction = () => {
    setProductDetails({})
  }
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Simulate loading by waiting for 3 seconds
    const timer = setTimeout(() => {
      setLoading(false); // Set loading to false after data is "loaded"
    }, 500);

    // Cleanup timer on component unmount
    return () => clearTimeout(timer);
  }, []);




  // {t("PRINT.TITLE")}



  var Experts = {
    dots: false,
    arrows: false,
    infinite: false,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 1,

    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          infinite: false,
          dots: false
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          arrows:true,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          arrows:true,
          slidesToScroll: 1
        }
      }
    ]
  };

  const getMainClassName = (id) => {
    const data = id === 2 ? "investmentnewui" : id === 5 ? "newrealestateui" : id === 3 ? "mortgagenewui" : id === 4 ? "bankingnewui" : id === 1 ? "insurancenewui" : null;
    return data
  }
  const getBanner = (id) => {
    const data = id === 2 ? Investmentbanner : id === 5 ? Realestatebanner : id === 3 ? Mortgagebanner : id === 4 ? Bankingbanner : id === 1 ? Insurancebanner : null;
    return data
  }
  const CONTENTKEY = mainCatID === 2 ? "INVESTMENT" : mainCatID === 5 ? "REALESTATE" : mainCatID === 3 ? "MORTGAGE" : mainCatID === 4 ? "BANKING" : mainCatID === 1 ? "INSURANCE" : null;

  const CategoryTextImage = mainCatID === 2 ? RealEtextInvest : mainCatID === 5 ? RealEtext : mainCatID === 3 ? RealEtextMor : mainCatID === 4 ? RealEtextBank : mainCatID === 1 ? RealEtextIns : null;
  const mainCategory = mainCatID === 2 ? "investment" : mainCatID === 5 ? "realEstate" : mainCatID === 3 ? "mortgage" : mainCatID === 4 ? "banking" : mainCatID === 1 ? "insurance" : null;
  const routeUrl = mainCatID === 2 ? "investment" : mainCatID === 5 ? "real-estate" : mainCatID === 3 ? "mortgage" : mainCatID === 4 ? "banking" : mainCatID === 1 ? "insurance" : null;
const sendCatId =() =>{
  sessionStorage.setItem("selectCategory",mainCatID)
}


  return (
    <>
    
      <section className={`container-rimib ${getMainClassName(mainCatID)} `}>
       <div>
      {loading ? (
        <div className="shimmer" style={{ width: '100%', height: '500px' }}></div> // This is where the shimmer will appear
      ) : (
        <section className="categorybanner">
       
         
          <div className="container makethecontainer">
            <div className="row">
              <div className="col-lg-6 col-sm-6 d-none d-sm-block" >
                <div className="bn-image">
                  <img src={getBanner(mainCatID)} alt='bannerDetails' />
                </div>
              </div>

              <div className="col-lg-6 col-sm-6">
                <div className="categorybannertext">
                  <div className="bannerfont borderbottom ">
                    {/* banner */}
                    <h2>{t(`CategoryContent.${CONTENTKEY}.BANNER`)}</h2>
                    {/* details */}
                    <p className="h6_style ">{t(`CategoryContent.${CONTENTKEY}.DETAILS`)}</p>
                    {/* sub header */}
                    <h6><Trans i18nKey={`CategoryContent.${CONTENTKEY}.SUBHEADER`}></Trans></h6>


                    {/* hints */}
                    <p className="bannersubtext">{t(`CategoryContent.${CONTENTKEY}.NOTES`)}  </p>
                    <Link to={'/AskTheExpert'} style={{ textDecoration: "none" }}>
                      <div className="askbutton">
                        <p className="askres"> {t("COMMON.ASKTHEEXPERTS")}</p>
                        <img src={iconaskbtn} alt="iconButton" />
                      </div>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        )}
    </div>
        <section className="categorysectionone">
          <OfferCardListJSX
            SubCatTitle={t("COMMON.OFFERHEADING")}
            SubCatText={t(`CategoryContent.${CONTENTKEY}.SUBHEADINGONE`)}
            SubCatTextLineOne={t(`CategoryContent.${CONTENTKEY}.SUBHEADINGTWO`)}
            offerData={offerData}
            redirectUrl="/offers"
            isDescription={true}
            mainCatID={mainCatID}
            isSlider={true}
          />
        </section>
        <div>
         {loading ? (
        <div className="shimmer" style={{ width: '100%', height: '500px' }}></div> // This is where the shimmer will appear
      ) : (
        <ProductCardList
          productData={productData}
          productTitle={t(`CategoryContent.${CONTENTKEY}.PRODUCTSTITLE`)}
          productsubTitleText={t(`CategoryContent.${CONTENTKEY}.PRODUCTSLIDERSUBTITLE`)}
          productsubTitleTextTwo={t(`CategoryContent.${CONTENTKEY}.PRODUCTSLIDERSUBTITLES`)}
          subCategoryLayout={true}
          isCategorySubCategory={true}
          isProductName={true}
          isViewButton={true}
          category={mainCategory}
          viewbuttonURL={setProductDetails}
        />
   )}
    </div>
    <div>
         {loading ? (
        <div className="shimmer" style={{ width: '100%', height: '500px' }}></div> // This is where the shimmer will appear
      ) : (
        <InstituteList
          instituteData={instituteData}
          topRatedText={t(`CategoryContent.${CONTENTKEY}.INSTITUIONSINCANADA`)}
          checkOutText={t(`CategoryContent.${CONTENTKEY}.TOPINSTITUDESUBTITLE`)}
          finalcialText={t(`CategoryContent.${CONTENTKEY}.TOPINSTITUDESUBTITLEOFFER`)}
          onInstituteClick={onInstituteClick}
          isCategory={true}
          categoryImg={CategoryTextImage}
          topText={t("COMMON.TOP")}
          category={mainCategory}
        />
)}
    </div>
        <section className="categorysectionfour bestdeals Experts">
          <div className="container">
            <h2 className="text-center expertheading">{t(`CategoryContent.${CONTENTKEY}.TOPEXPERT`)}</h2>
            <h5 className="text-center  h5_style expertsub1">{t(`CategoryContent.${CONTENTKEY}.EXPERTHEADING`)}<br />
            </h5>
            <p className="expertsub2 text-center">{t(`CategoryContent.${CONTENTKEY}.EXPERTSUBHEADING`)}</p>
            <div className=" p bestdealsbox bestexperts">
              {expertData?.length > 0 ?
                <Slider {...Experts}>
                  {expertData?.map(data => {
                    return <ExpertCardJsx data={data} CategoryID={data?.expertSpecializations[0]?.institutionCategoryId} />
                  })}
                </Slider>
                :
                <div className="dropdefault text-center">
                  <div className="dropdefaultimage">
                    <img src={dropbox} alt={'dropBox '} />
                  </div>
                  <div className="dropdefaulttext">
                    <h5 className="opacity0"> {t("COMMON.NORECORDFOUND")}</h5>
                  </div>
                </div>
              }
              <div className="latestbutton  marginbottom">
                <Link to="/globalMainSearchExpert" className="showallourbesttoo " style={{ textDecoration: "none" }}>{t("COMMON.SHOWALL")}</Link>
              </div>
            </div>
          </div>
        </section>
        <section className="categorysectionfive">
          <div className="container">
            <div className="realEquestion">
              <div className="realEquestiontext">
                <h2><Trans i18nKey={`CategoryContent.${CONTENTKEY}.BANNERHEADER`}></Trans></h2>
                <h3><Trans i18nKey={`CategoryContent.${CONTENTKEY}.BANNERSUBHEADER`}></Trans></h3>


                <Link to={'/AskTheExpert'} style={{ textDecoration: "none" }}>
                  <div className="realEbuttonmain realEmargin askbuttoncomm">
                    <p className="realEbutton">{t("COMMON.ASKTHEEXPERTS")}</p>
                    <img src={iconaskbtn} alt="iconButton" />
                  </div>
                </Link>
              </div>
            </div>
          </div>
        </section>
        <div>
         {loading ? (
        <div className="shimmer" style={{ width: '100%', height: '500px' }}></div> // This is where the shimmer will appear
      ) : (
        <section className="categorysectionsix blogdetailsexpertppv">
          <div className="container">
            <div className="realEbloginner">
              <h2 className="text-center">{t(`CategoryContent.${CONTENTKEY}.ARTICLEHEADER`)}</h2>
              <p className="text-center realEblogtext"><Trans i18nKey={`CategoryContent.${CONTENTKEY}.ARTICLESUBHEADER`}></Trans>
              </p>
            </div>
            <div className="row realEbloglog">
              {
                blogData?.body?.length > 0 ?
                  blogData?.body?.slice(0, visibleBlogs).map(blog => {
                    return <div className="col-lg-6 col-md-6 col-sm-6 minheightrealestate">
                      <ArticlesCardJSX
                        blogslug={blog?.slug}
                        blogimage={blog?.image}
                        blogtitle={blog?.title}
                        blogshort_content={blog?.short_content}
                      />
                    </div>
                  }) :
                  <div className="dropdefault text-center">
                    <div className="dropdefaultimage">
                      <img src={dropbox} alt={'dropbox '} />
                    </div>
                    <div className="dropdefaulttext">
                      <h5>You don't have any Blogs yet. </h5>
                    </div>
                  </div>
              }
              <div className="latestbutton" onClick={sendCatId}>
                <Link to={{ pathname: `/articles`, search: `?category=${routeUrl}` }} className="showallourbesttoo">
                  {t("COMMON.SHOWALL")}
                </Link>
              </div>
            </div>
          </div>
        </section>
        )}
    </div>
        <section>
        </section></section>
    
    
     
    <Footer />
      {productDetails?.data &&
        <DetailedProductsJsx data={productDetails?.data} category={productDetails?.category} subCategory={productDetails.subCategory} closFunction={closeFunction} />
      }
    </>
  );
};

export default CategoryJsx;
